import { useQuery } from "@tanstack/react-query";
import type { UserAccessResponse } from "../types/userAccess";
import { HttpClient } from "./axiosConfig";

export const useUserAccess = (options?: {
  refetchOnMount?: boolean | 'always'}) => {
  return useQuery({
    queryKey: ['userAccess'],
    queryFn: async () => {
      const result = await HttpClient.get<UserAccessResponse>('users/user-access');
      return result.data.data ?? null;
    },
    refetchOnMount: options?.refetchOnMount ?? false,
  });
};


export const useProfileMenu = () => {
  return useQuery({
    queryKey: ['profileMenu'],
    queryFn: async () => {
      const result = await HttpClient.get<UserAccessResponse>('users/profile-menus');
      return result.data.data ?? null;
    },
  });
};
